import { getCmsUsefulInfoDetailAction } from "../../../Actions/LogicActions/Search/GetCmsUsefulInfoDetailAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { IGetCmsUsefulInformationActionParams } from "../../../Orchestrator/Types/Interface/ICmsUsefulInformaton";

class UsefulInfoDetailInitStep extends StepFlow {
  get stepName() {
    return "UsefulInfoDetailInit_Step";
  }

  async onEventSetup(): Promise<void> {
    this.registerEventSubscription(
      _eventBus.on<IGetCmsUsefulInformationActionParams, void>({
        eventName: evtTree.helpInfo.Details.Get,
        handler: async ({ data }) => {
          if (data?.slug) {
            getCmsUsefulInfoDetailAction.setParams(data!);
            getCmsUsefulInfoDetailAction.execute();
          }
        },
      })
    );
  }

  async onExecute(): Promise<void> {}
}

export const UsefulInfoDetailInitStepDeclaration = new StepDefinition({
  stepName: "UsefulInfoDetailInit_Step",
  stepClass: UsefulInfoDetailInitStep,
});
